/* AUTO-GENERATED. Do not edit by hand. */

/**
 * @remixicon/react v4.1.0 - Apache-2.0
 */
import type { RemixiconComponentType } from '../types'

/**
 * RiPercentLine icon component from Remix Icon set.
 * 
 * @param props - RemixiconProps
 * @returns JSX element representing the RiPercentLine icon
 */
const RiPercentLine: RemixiconComponentType = (props): JSX.Element => {
  // Extract RemixiconProps
  const {
    color = 'currentColor',
    size = 24,
    ...rest
  } = props

  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
      fill={color}
      width={size}
      height={size}
      {...rest}
    >
      <path fill="currentColor" d="M17.505 21.003a3.5 3.5 0 1 1 0-7a3.5 3.5 0 0 1 0 7m0-2a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m-11-9a3.5 3.5 0 1 1 0-7a3.5 3.5 0 0 1 0 7m0-2a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m12.571-4.486l1.414 1.415L4.934 20.488L3.52 19.074z"/>
    </svg>
  )
}

export default RiPercentLine
